export const CITIES = {
  mumbai: 'mumbai',
  delhi_NCR: 'delhi ncr',
  delhi: 'delhi',
  bangalore: 'bangalore',
  hyderabad: 'hyderabad',
  chennai: 'chennai',
  ahmedabad: 'ahmedabad',
  jaipur: 'jaipur',
  pune: 'pune',
  kolkata: 'kolkata',
  surat: 'surat',
  lucknow: 'lucknow',
  coimbatore: 'coimbatore',
  indore: 'indore',
  nagpur: 'nagpur',
  chandigarh: 'chandigarh',
  vadodara: 'vadodara',
  ludhiana: 'ludhiana',
  kochi: 'kochi',
  nashik: 'nashik',
  visakhapatnam: 'visakhapatnam',
  kanpur: 'kanpur',
  trivandrum: 'trivandrum',
  tiruppur: 'tiruppur',
  kozhikode: 'kozhikode',
  rajkot: 'rajkot',
  bhopal: 'bhopal',
  anand: 'anand',
  agra: 'agra',
  meerut: 'meerut',
  thrissur: 'thrissur',
  madurai: 'madurai',
  gwalior: 'gwalior',
  aurangabad: 'aurangabad',
  mysore: 'mysore',
  jabalpur: 'jabalpur',
  nadiad: 'nadiad',
  salem: 'salem',
  vijayawada: 'vijayawada',
  jalandhar: 'jalandhar',
  bharuch: 'bharuch',
  ambala: 'ambala',
  raipur: 'raipur',
  bhilai: 'bhilai',
  mangalore: 'mangalore',
  patna: 'patna',
  prayagraj: 'prayagraj',
  jodhpur: 'jodhpur',
  ajmer: 'ajmer',
  kota: 'kota',
  varanasi: 'varanasi',
  bhavnagar: 'bhavnagar',
  jamnagar: 'jamnagar',
  ujjain: 'ujjain',
  ranchi: 'ranchi',
  jalgaon: 'jalgaon',
  goa: 'goa',
  guwahati: 'guwahati',
  panipat: 'panipat',
  bhubaneswar: 'bhubaneswar',
  ayodhya: 'ayodhya',
  dubai: 'dubai',
  sharjah: 'sharjah',
  istanbul: 'istanbul',
  dhaka: 'dhaka',
} as const;

export const CITY_TO_GEO_REGION_ID: Record<string, number> = {
  [CITIES.mumbai]: 1,
  [CITIES.delhi_NCR]: 2,
  [CITIES.delhi]: 2,
  [CITIES.bangalore]: 3,
  [CITIES.hyderabad]: 4,
  [CITIES.chennai]: 5,
  [CITIES.ahmedabad]: 6,
  [CITIES.jaipur]: 7,
  [CITIES.pune]: 8,
  [CITIES.kolkata]: 9,
  [CITIES.surat]: 10,
  [CITIES.lucknow]: 11,
  [CITIES.coimbatore]: 12,
  [CITIES.indore]: 13,
  [CITIES.nagpur]: 14,
  [CITIES.chandigarh]: 15,
  [CITIES.vadodara]: 16,
  [CITIES.ludhiana]: 17,
  [CITIES.kochi]: 18,
  [CITIES.nashik]: 19,
  [CITIES.kanpur]: 20,
  [CITIES.visakhapatnam]: 29,
  [CITIES.trivandrum]: 30,
  [CITIES.tiruppur]: 1032,
  [CITIES.kozhikode]: 1033,
  [CITIES.rajkot]: 1034,
  [CITIES.bhopal]: 1035,
  [CITIES.anand]: 1036,
  [CITIES.agra]: 1037,
  [CITIES.meerut]: 1038,
  [CITIES.thrissur]: 1040,
  [CITIES.madurai]: 1041,
  [CITIES.gwalior]: 1042,
  [CITIES.aurangabad]: 1043,
  [CITIES.mysore]: 1044,
  [CITIES.jabalpur]: 1045,
  [CITIES.nadiad]: 1046,
  [CITIES.salem]: 1047,
  [CITIES.vijayawada]: 1048,
  [CITIES.jalandhar]: 1049,
  [CITIES.bharuch]: 1050,
  [CITIES.ambala]: 1051,
  [CITIES.raipur]: 1052,
  [CITIES.bhilai]: 1053,
  [CITIES.mangalore]: 1054,
  [CITIES.patna]: 1055,
  [CITIES.prayagraj]: 1056,
  [CITIES.jodhpur]: 1057,
  [CITIES.ajmer]: 1058,
  [CITIES.kota]: 1059,
  [CITIES.varanasi]: 1060,
  [CITIES.bhavnagar]: 1061,
  [CITIES.jamnagar]: 1062,
  [CITIES.ujjain]: 1063,
  [CITIES.ranchi]: 2064,
  [CITIES.jalgaon]: 2065,
  [CITIES.goa]: 2066,
  [CITIES.guwahati]: 2067,
  [CITIES.panipat]: 2068,
  [CITIES.bhubaneswar]: 2069,
  [CITIES.ayodhya]: 2070,
  [CITIES.dubai]: 3,
  [CITIES.sharjah]: 3,
  [CITIES.istanbul]: 3,
  [CITIES.dhaka]: 3,
};

const DEFAULT_GEO_REGION_ID = 3;

export function cityToGeoRegionId(city: string): number {
  return CITY_TO_GEO_REGION_ID[city.toLowerCase()] ?? DEFAULT_GEO_REGION_ID;
}
